import AbstractApiReducer from "services/cores/abstractApiReducer";
import HeatmapOccupancyActionTypes from "./types";

const instance = new AbstractApiReducer(HeatmapOccupancyActionTypes, {
  list: {
    timestamp: undefined,
    points: [],
  },
});
export default instance.reducer;
